import React, { useContext, useEffect, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import { Accordion, AccordionItem } from '@react/react-spectrum/Accordion'
import '../../style/console.css'
import { setBodyHeight } from '../../lib/easybake'
import ConsoleSteps from './ConsoleSteps'
import WizardProjectInfo from '../Nav/WizardProjectInfo'
import WizardAccessToken from '../Nav/WizardAccessToken'
import WizardHelloWorld from '../Nav/WizardHelloWorld'
import TilePsApiSdk from '../Nav/TilePsApiSdk'
import TilePsApiReference from '../Nav/TilePsApiReference'

export default function BuildSomethingCool () {
    const { page, dispatch } = useContext(EasybakeContext)

    useEffect(() => {
        setBodyHeight('adobe-easybake-main-sub-pane')
    }, [])

    return <div className="adobe-easybake-main-sub-pane">
        <div className="adobe-easybake-main-sub-pane-contents-signup">
            <div className="adobe-easybake-main-sub-pane-header">
                <ConsoleSteps referrer={page}/>
                <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_credinfo_title')}</Heading>
                <hr className="adobe-easybake-hr" />
            </div>
            <div className="adobe-easybake-main-contents">
                <Accordion defaultSelectedIndex={3} multiselectable>
                    <AccordionItem header="Your project information is below:">
                        <WizardProjectInfo />
                    </AccordionItem>
                    <AccordionItem header="Generate access token">
                        <WizardAccessToken />
                    </AccordionItem>
                    <AccordionItem header="Test your credentials">
                        <WizardHelloWorld />
                    </AccordionItem>
                    <AccordionItem header={__('signup_wizard_title6')}>
                        <div className="adobe-easybake-flex-row-space-between">
                            <TilePsApiSdk />
                            <TilePsApiReference />
                        </div>
                    </AccordionItem>
                </Accordion>
            </div>
        </div>
    </div>
}
